import analyticsService from "src/services/Analytics.service";

export const trackLogout = () => analyticsService.track("logout");

export const trackSetPassword = (email: string) => analyticsService.track("set-password", { email });

export const trackResetPassword = (email: string) => analyticsService.track("reset-password", { email });
